import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	ElementRef,
	Input,
	QueryList,
	ViewChild,
	ViewChildren,
} from "@angular/core";
import {EmployeeProfileComponent} from "./employee-profile/employee-profile.component";
import {TranslatableComponent} from "../../../../core/models/TranslatableComponent";
import {TranslateService} from "@ngx-translate/core";
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Highcharts from "highcharts";
import {HighchartsChartComponent} from "../../../../shared/highcharts-chart/highcharts-chart.component";
import {MatIcon} from "@angular/material/icon";

@Component({
	selector: "app-employee-request-result",
	templateUrl: "./employee-request-result.component.html",
	styleUrls: ["./employee-request-result.component.scss"],
	imports: [HighchartsChartComponent, MatIcon, EmployeeProfileComponent],
})
export class EmployeeRequestResultComponent extends TranslatableComponent implements AfterViewInit {
	@Input() position!: any;
	@Input() index!: number;

	@ViewChild("component") component!: ElementRef<HTMLDivElement>;
	@ViewChild("requestedSkillsList") requestedSkillsList!: ElementRef<HTMLUListElement>;
	@ViewChild("canvasContainer") canvasContainer!: ElementRef<HTMLDivElement>;
	@ViewChild("employeeProfileButtonRow") employeeProfileButtonRow!: ElementRef<HTMLDivElement>;

	@ViewChildren("employeeProfileButton") employeeProfileButtons!: QueryList<ElementRef>;
	@ViewChildren("employeeProfile") employeeProfiles!: QueryList<EmployeeProfileComponent>;

	public reqSkillNames: string[] = [];
	private reqSkillLevel: number[] = [];
	private reqSkillNamesWOLevel: string[] = [];
	private canvasInit: boolean = false;
	public expandedButtonIndex: number = -1;
	public requestedSkillsChartOptions: Highcharts.Options;

	constructor(
		private cdr: ChangeDetectorRef,
		private _translate: TranslateService,
	) {
		super(_translate, "ChatBotComponent");
	}

	ngAfterViewInit() {
		this.updateRequestedSkills(this.position.requestedSkills);
		this.initializeCanvases();
		this.cdr.detectChanges();
	}

	updateRequestedSkills(requestedSkills: any[]) {
		let chartIndex: number = 0;
		let listIndex: number = 0;
		this.reqSkillNames = [];
		this.reqSkillLevel = [];
		this.reqSkillNamesWOLevel = [];
		for (let i = 0; i < requestedSkills.length; i++) {
			if (requestedSkills[i].levels) {
				this.reqSkillNames[chartIndex] = requestedSkills[i].name;
				this.reqSkillLevel[chartIndex] = this.returnSkillLevelFromArray(requestedSkills[i].levels);
				chartIndex++;
			} else {
				this.reqSkillNamesWOLevel[listIndex] = requestedSkills[i].name;
				listIndex++;
			}
		}
		this.reqSkillNamesWOLevel.forEach((name) => {
			const liElement = document.createElement("li");
			liElement.textContent = name;
			this.requestedSkillsList.nativeElement.appendChild(liElement);
		});

		if (this.canvasInit) {
			this.checkReqSkillsVisibility();
		}

		if (this.position.matchingEmployees.length > 3) {
			this.employeeProfileButtonRow.nativeElement.style.justifyContent = "flex-start";
		} else {
			this.employeeProfileButtonRow.nativeElement.style.justifyContent = "center";
		}
	}

	returnSkillLevelFromArray(levels: string[]): number {
		switch (levels[levels.length - 1]) {
			case "beginner":
				return 1;
			case "advanced":
				return 2;
			case "experienced":
				return 3;
			case "professional":
				return 4;
			case "expert":
				return 5;
			default:
				return 0;
		}
	}

	checkReqSkillsVisibility() {
		if (this.reqSkillNames[0]) {
			this.canvasContainer.nativeElement.style.display = "block";
		} else {
			this.canvasContainer.nativeElement.style.display = "none";
		}

		if (this.reqSkillNamesWOLevel[0]) {
			this.requestedSkillsList.nativeElement.style.display = "block";
		} else {
			this.requestedSkillsList.nativeElement.style.display = "none";
		}
	}

	handleProfileButtonClick(buttonIndex: number) {
		this.expandedButtonIndex = buttonIndex;
		this.employeeProfiles.get(buttonIndex)?.selectEmployee();
		this.employeeProfileButtons
			.filter((_, i) => i !== buttonIndex)
			.forEach((button) => {
				button.nativeElement.style.display = "none";
			});
		if (this.position.matchingEmployees.length > 3) {
			this.employeeProfileButtonRow.nativeElement.style.justifyContent = "center";
		}
	}

	resetProfileButtonRow() {
		this.employeeProfiles.forEach((profile) => {
			profile.unSelectEmployee();
		});
		this.employeeProfileButtons.forEach((button) => {
			button.nativeElement.style.display = "block";
		});
		this.expandedButtonIndex = -1;
		if (this.position.matchingEmployees.length > 3) {
			this.employeeProfileButtonRow.nativeElement.style.justifyContent = "flex-start";
		}
	}

	initializeCanvases() {
		if (this.reqSkillNames[0]) {
			this.requestedSkillsChartOptions = {
				chart: {
					type: "column",
					animation: false,
				},
				title: {
					text: null, // No title specified in the original Chart.js configuration
				},
				yAxis: {
					min: 0,
					max: 5,
					title: {
						text: "Skill-Level", // Adding a title to match the dataset label
					},
					tickInterval: 1,
				},
				xAxis: {
					categories: this.reqSkillNames,
					title: {
						text: null, // No xAxis title in the original configuration
					},
				},
				series: [
					{
						name: "Level",
						data: this.reqSkillLevel,
						type: "column",
						color: "var(--mep-color-primary)", // Matching the background color of the bars
					},
				],
				plotOptions: {
					series: {
						borderWidth: 0,
					},
				},

				credits: {
					enabled: false, // Disables the Highcharts credits
				},
				legend: {
					enabled: false, // Disable legend
				},
			};
		}
		this.canvasInit = true;
	}
}
